<template>
	<div>
		<div style="width:1200px;margin: 0 auto;">
			<div class="dingdan">
				<el-breadcrumb separator-class="el-icon-arrow-right">
				  <el-breadcrumb-item :to="{ path: '/serviceHome/MyReview' }">我的评审</el-breadcrumb-item>
				  <el-breadcrumb-item>评审详情</el-breadcrumb-item>
				</el-breadcrumb>
				<div class="fh_button" @click="fanhui" style="cursor:pointer;">
					<i class="el-icon-arrow-left"></i>
					<p>返回</p>
				</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">发起评审的阶段</h3>
				<div class="Reviewdiv">需求方在<span v-if="datails.review.stage==1">承认图 </span> <span v-else>生产图</span>阶段发起了评审，请评审员仔细查看双方信息进行评审</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">需求详情</h3>
				<div class="Reviewdiv1"> 
				     <span>{{datails.order.demand.description}}</span>
				</div>
				<div class="Reviewdiv2">
					<div class="Reviewdiv2_1">
						<h4>相关图片</h4>
						<div>
							<imglist :file="datails.order.demand.file" type='1'></imglist>
		<!-- 					<figure v-if="datails.order.demand.file.length==0" style="width:100%;text-align: center;">
								<img src="@/assets/kong.png" alt="" srcset="" />
							</figure> -->
						</div>
					</div>
					<div  class="Reviewdiv2_1">
						<h4>验收标准</h4>
						<div style="display:flex;">
							<div style="position:relative;margin-top:0;width: auto;">
								<imglist :file="[datails.order.demand.confirm_image]" v-if="datails.order.demand.confirm_image"  width="72px" height="72px"></imglist>
								<img src="@/assets/WuData.png" alt="" srcset="" 
								     v-if="!datails.order.demand.confirm_image"  
								     style="width:72px;height:72px;border-radius:6px;margin-top:0;"/>
								<div style="" class="dingwei">承认图</div>
							</div>
							<div style="position:relative;margin-top:0;width: auto;">
								<imglist :file="[datails.order.demand.produce_image]" v-if="datails.order.demand.produce_image"  width="72px" height="72px"></imglist>
								<img src="@/assets/WuData.png" alt="" srcset="" 
								   v-if="!datails.order.demand.produce_image"  
								   style="width:72px;height:72px;border-radius:6px;margin-top:0;"/>
								<div style="" class="dingwei">生产图</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="ReviewDatails">
				<h3 class="ReviewH3">验收相关信息</h3>
				<div class="ReviewView">
					<p>服务方提交内容</p>
				</div>
				<ul class="ReviewUl">
					<li>中标时间：<span>{{datails.order.create_time}}</span></li>
					<li>服务方交付周期：<span>{{datails.order.period_format}}</span></li>
					<li>一阶段承认图：<span>{{datails.review.orderStage.period_format}}</span></li>
					<li>二阶段生产图：<span>{{datails.review.orderStage.period_format}}</span></li>
				</ul>
				<h4 style="line-height:50px;">服务方提供的验收相关材料</h4>
				<div class="jfimglist">
					
					<rightsidebarImg :list="orderfile"></rightsidebarImg>
<!-- 					<div v-for="(i,index) in datails.order.file"  :key="i" class="jfimg">
						<div class="jfimgbox">
							<el-image
							    style="width:42px;height:42px;border-radius:6px;margin-right:5px;"
							    :src="i.file"
							    :preview-src-list="i.file">
							</el-image>
							<div>
								<span v-if="i.stage==1">{{index+1}},承认图</span>
								<span v-if="i.stage==2">{{index+1}},生产图</span>
								<p>{{i.create_time}}</p>
							</div>
						</div>
						<span>查看</span>
					</div> -->
				</div>
			</div>
			<div class="ReviewDatails2">
			   <div class="Reviewlist">
				   <div class="Reviewser">
					   <h4>需求方原因说明</h4> <span>{{datails.review.pay_time*1000 | dateFormat}}</span>
				   </div>
				   <div class="Reviewser1">
					   <h4>原因说明</h4>
					   <p>{{datails.review.demand_content}}</p>
					    <h4>相关问题附件</h4>
						<div style="display:flex;">
							<imglist :file="datails.review.demand_image"  width="80px" height="80px" type="1"></imglist>
						</div>
				   </div>
			   </div>
			   <div class="Reviewlist">
				   <div class="Reviewser">
				   		<h4>服务方原因说明</h4> 
						<span v-if="datails.review.defense_time>0">{{datails.review.defense_time*1000 | dateFormat}}</span>
						<span v-if="datails.review.defense_time==0 && datails.review.service_content ==''">超时未辩护</span>
				   </div>
				  <div class="Reviewser1">
					   <h4>原因说明</h4>
					   <p>{{datails.review.service_content}}</p>
						<h4>相关问题附件</h4>
						<div style="display:flex;">
							<imglist :file=" datails.review.service_image" width="80px" height="80px" type="1"></imglist>
						</div>
				   </div>
			   </div>
			</div>
			<div class="ReviewDatails" v-if="datails.status==1" style="margin-top:20px;">
				<h3 class="ReviewH3">我的评审</h3>
				<div class="ReviewPS">
					<h4>我所选的支持方</h4>
					<div class="ReviewZCF" v-if="datails.support==1">
						<img src="@/assets/fabu.png" alt="" srcset="" />
						<span>需求方</span>
						<span v-if="datails.review.win==1">(胜方)</span>
						<span v-if="datails.review.win==2">(败方)</span>
						<span v-if="datails.review.win==0">(暂无评审结果)</span>
					</div>
					<div class="ReviewZCF" v-if="datails.support==2">
						<img src="@/assets/xuqiu.png" alt="" srcset="" />
						<span>服务方</span>
						<span v-if="datails.review.win==1">(败方)</span>
						<span v-if="datails.review.win==2">(胜方)</span>
						<span v-if="datails.review.win==0">(暂无评审结果)</span>
					</div>
					<h4>我的评审意见</h4>
					<div class="ReviewPSYJ">
						<span>{{datails.content}}</span>
					</div>
				</div>
			</div>
			<div class="ReviewFooter">
				<p class="ReviewFooterP" v-if="datails.status==0">提示：支持方为败方或者未评审将无法获得评审金</p>
				<h4 class="ReviewFooterH4" v-if="datails.status==-1">过期未评审</h4>
			</div>
		</div>
		
		<div  v-if="datails.status==0" @click="qingshen(datails.oru_id)" class="pingshen">立即评审</div>
		
		<el-dialog
		  title="立即评审"
		  :visible.sync="centerDialogVisible"
		  width="810px">
		  <div class="FBxq">
			<h4>选择支持方<span>*</span></h4>
			<p>请根据实际情况选择您支持的一方</p>
			<div class="fuwulist">
				<div class="fuwulist1" :class="{'xuanzhong':radio==1}">
					<el-radio v-model="radio" :label="1" fill="#1E3A8A">
						<div class="fuwulist1_1">
							<img src="@/assets/fabu.png" alt="" srcset="" />
							<span>需求方</span>
						</div>
					</el-radio>
				</div>
				<div class="fuwulist1" :class="{'xuanzhong':radio==2}">
					<el-radio v-model="radio" :label="2" fill="#1E3A8A">
						<div class="fuwulist1_1">
							<img src="@/assets/xuqiu.png" alt="" srcset="" />
							<span>服务方</span>
						</div>
					</el-radio>
				</div>
			</div>
			<h4 style="margin-top:24px;">评审意见<span>*</span></h4>
			<p>请详细说明您的评审理由和依据</p>
			<div class="FBxqText">
				<textarea name="" id="" cols="30" rows="10" v-model="content" placeholder="请输入内容"></textarea>
			</div>
			<div class="FBxqFooter">
				<div class="FBxqFooter1"  @click="quxiao">取消</div>
				<div class="FBxqFooter2" @click="Addreview">提交评审</div>
			</div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		OrderReviewUserDetail,
		OrderReviewUserJudge
	} from "@/api/api.js";
	import imglist from '@/common/imglist.vue'
	import rightsidebarImg from '@/common/rightsidebarImg.vue';
	export default {
	  name: 'HelloWorld',
	  components:{
		imglist,
		rightsidebarImg
	  },
	  data() {
	    return {
		   curNow:0 , //0为需求方信息 1为服务方信息
		   oruId:"",
		   datails:"",
		   centerDialogVisible:false,
		   radio:0,
		   content:"",
		   orderfile:[]
	    }
	  },
	  computed: {
		oru_id() {
		   return this.$route.query.oru_id || ''
		}
	  },
	  mounted() {
	     this.getdatails()
	  },
	  methods: {
		  fanhui(){
		  	this.$router.go(-1)  
		  },
		  qingshen(){
			  this.centerDialogVisible=true
		  },
		  getdatails(){
		  	OrderReviewUserDetail(this.oru_id,{
		  		
		  	}).then(res=>{
				this.orderfile=[]
		  		this.datails=res.data.data
				if(this.datails.review.orderStage.files.length>0){
					this.orderfile=this.datails.review.orderStage.files
					this.orderfile.forEach(item=>{
							item.type=this.getFileType(item.file)
					})
					console.log(this.orderfile)
				}
		  	})
		  },
		  getFileType(url) {
		    const extension = url.split('.').pop().toLowerCase();
		    const typeMap = {
		  	'jpg': 'image',
		  	'jpeg': 'image',
		  	'png': 'image',
		  	'gif': 'image',
		  	'zip': 'zip',
		  	'rar': 'zip',
		  	'pdf': 'pdf'  ,// 根据实际需求可调整
		  	
		    };
		    return typeMap[extension] || 'unknown';
		  },
		  
		  
		  quxiao(){
		  	this.content=""
		  	this.centerDialogVisible = false
		  },
		  Addreview(){
		  	if(this.content==""){
		  		this.$message.error('评审意见不能为空')
		  		return
		  	}
		  	OrderReviewUserJudge(this.oru_id,{
		  		support:this.radio,
		  		content:this.content
		  	}).then(res=>{
		  		if(res.data.status==200){
		  			this.$message.success("评审成功")
					this.centerDialogVisible=false,
		  			this.getdatails()
		  		}
		  	})
		  },
	  },
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
		position: relative;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.ReviewDatails{
		width:100%;
		background-color:#fff;
		border-radius:12px;
		padding:20px;
		box-sizing: border-box;
		margin-bottom:24px;
	}
	.ReviewH3{
		font-weight: bold;
		font-size: 16px;
		color: #333333;
	}
	.Reviewdiv{
		width:100%;
		background: rgba(66,151,255,0.1);
		border-radius: 8px 8px 8px 8px;
		padding:20px;
		box-sizing: border-box;
		font-weight: 500;
		font-size: 16px;
		color: rgba(255,0,0,0.8);
		text-align: center;
		margin-top:18px;
	}
	:v-deep .el-radio {
		display:flex;
		align-items:center;
	}
	.xuanzhong{
		background-color:#DDE2EE !important;
	}
	::v-deep .el-radio__input.is-checked+.el-radio__label {
	    color: #333;
	}
	
	
	::v-deep .imglist{
		width: 280px;
		margin-right: 10px;
	}
	::v-deep .jfimglist>div{
		display:flex;
		flex-wrap:wrap;
	}
	.Reviewdiv1{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-top:12px;
	}
	span{
		word-break: break-all;
		word-wrap: break-word;
		white-space: pre-wrap;
	}
	.Reviewdiv2{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:24px;
	}
	.Reviewdiv2_1{
		width:50%;
		padding-right:10px;
		box-sizing: border-box;
	}
	.Reviewdiv2_1 h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.Reviewdiv2_1 div{
		width:100%;
		display:flex;
		align-items: center;
		margin-top:12px;
	}
	.Reviewdiv2_1 img{
		width:72px;
		height:72px;
		border-radius: 8px 8px 8px 8px;
		margin-right:16px;
	}
	.ReviewView{
		width:100%;
		margin-top:18px;
	}
	.dingwei{
		position:absolute;
		width:72px !important;
		height:30px;
		display:flex;
		align-items: center;
		justify-content:center;
		color: #666;
		bottom: 0;
		background:rgba(255,255,255,0.8);
		border-radius:6px 6px 0px 0px;
		margin-top:0 !important;
		padding-top:0 !important;
	}
	.ReviewView p{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.ReviewView p>span{
		font-weight: 400;
		font-size: 14px;
		color: rgba(255,0,0,0.8);
	}
	.ReviewUl{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:12px;
		font-weight: 400;
		font-size: 14px;
		color: #666666;
	}
	.ReviewUl span{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.jfimglist{
		width:100%;
		display: flex;
		flex-wrap:wrap;
	}
	.jfimg{
		width: 374px;
		height: 66px;
		background: rgba(30,58,138,0.15);
		border-radius: 12px 12px 12px 12px;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-right:12px;
		margin-bottom:12px;
		padding:12px;
		box-sizing: border-box;
	}
	.jfimglist>div:nth-child(3n){
		margin-right:none;
	}
	.jfimgbox{
		display:flex;
		align-items:center;
	}
	.jfimgbox img{
		width:42px;
		height:42px;
		border-radius:6px;
		margin-right:5px;
	}
	.jfimgbox span{
		font-weight: 500;
		font-size: 14px;
		color: #1E3A8A;
	}
	.jfimgbox p{
		font-weight: 400;
		font-size: 12px;
		color: rgba(30,58,138,0.6);
	}
	.jfimg>span{
		font-weight: 400;
		font-size: 14px;
		color: #4297FF;
	}
	.Reviewlist{
		width: 588px;
		background: #FFFFFF;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.05);
		border-radius: 12px 12px 12px 12px;
		padding:12px;
		box-sizing: border-box;
	}
	.ReviewDatails2{
		width:100%;
		display:flex;
		justify-content:space-between;
	}
	.Reviewser{
		width:100%;
		display:flex;
		justify-content:space-between; 
		align-items: center;
	}
	.Reviewser span{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.Reviewser1>h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		line-height:30px;
	}
	.Reviewser1>p{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
		margin-bottom:12px;
	}
	.ReviewFooter{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		flex-wrap:wrap;
		padding:30px 0px;
	}
	.ReviewFooterP{
		font-weight: 400;
		font-size: 14px;
		color: #FF0000;
		margin-bottom:10px;
	}
	.ReviewFooterH4{
		font-weight: 500;
		font-size: 16px;
		color: #999999;
	}
	.ReviewPS h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
		line-height:40px;
	}
	.ReviewZCF{
		display:flex;
		align-items:center;
	}
	.ReviewZCF img{
		width:24px;
		height:24px;
		margin-right:5px;
	}
	.ReviewZCF span{
		font-weight: 500;
		font-size: 14px;
		color: #333333;
	}
	.ReviewPSYJ{
		font-weight: 400;
		font-size: 14px;
		color: #333333;
	}
	
	
	.fuwulist{
		width:100%;
		display:flex;
		justify-content:space-between;
		align-items: center;
		margin-top:20px;
	}
	.fuwulist1{
		width: 373px;
		height: 90px;
		background: #EFF0F1;
		border-radius: 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.fuwulist1 img{
		width:42px;
		height:42px;
		margin-right:10px;
	}
	.fuwulist1_1{
		display:flex;
		align-items:center;
	}
	::v-deep .el-radio {
		display:flex;
		align-items:center;
	}
	.xuanzhong{
		background-color:#DDE2EE !important;
	}
	::v-deep .el-radio__input.is-checked+.el-radio__label {
	    color: #333;
	}
	.FBxq>h4{
		font-weight: bold;
		font-size: 14px;
		color: #333333;
	}
	.FBxq>h4>span{
		font-weight: bold;
		font-size: 14px;
		color: #FF0000;
	}
	.FBxq>p{
		font-weight: 400;
		font-size: 12px;
		color: #666666;
	}
	.FBxqText{
		width:100%;
		margin-top:20px;
	}
	.FBxqText textarea{
		width:100%;
		height: 177px;
		resize: none;
		outline:none;
		background: #FFFFFF;
		border-radius: 8px 8px 8px 8px;
		border: 1px solid rgba(30,58,138,0.2);
		padding:10px;
		box-sizing: border-box;
	}
	.FBxqFooter{
		width:100%;
		padding:10px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.FBxqFooter1{
		width: 112px;
		height: 40px;
		background: rgba(30,58,138,0.15);
		border-radius: 8px ;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #1E3A8A;
		cursor:pointer;
	}
	.FBxqFooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		border-radius: 8px ;
		margin-left:32px;
		display:flex;
		justify-content:center;
		align-items:center;
		font-weight: 500;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
	}
	.pingshen{
		width: 80px;
		height: 80px;
		background: #FF5900;
		box-shadow: 0px 4px 4px 0px rgba(0,0,0,0.25);
		border-radius: 100px 100px 100px 100px;
		position:fixed;
		top: 50%;
		margin-top: -40px;
		right:20%;
		display:flex;
		justify-content:center;
		align-items: center;
		font-weight: 800;
		font-size: 16px;
		color: #FFFFFF;
		cursor:pointer;
	}
</style>